import { useLocation } from 'wouter'

import { CreateLinkForm } from '@/templates/CreateLinkForm'
import { Layout } from '@/Layout'

export const CreateLink = () => {
  const [, setLocation] = useLocation()

  return (
    <Layout title="Create Link" showBackButton showCreateButton={false}>
      <CreateLinkForm
        defaultValues={{
          slug: '',
          destinations: [''],
        }}
        actionLabel="Create"
        onSuccess={(link) => {
          localStorage.setItem('newLink', JSON.stringify(link))
          setLocation('/')
        }}
        onCancel={() => setLocation('/')}
      />
    </Layout>
  )
}
